
import { computed, defineComponent, onMounted, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// types
import { PeriodT } from '@/core/types/companies.types'
import { DataState } from '@/core/classes/DataState.class'

// composable
import useHelpers from '@/common/composable/useHelpers'
import { orders } from '@/core/realisations/orders.realisation'

export default defineComponent({
    components: {
        Modal,
        TheInput,
        TheSelect,
        Checkbox,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const { findObjectByValue } = useHelpers()

        const state = reactive({
            is_period_check: false,
            date: null as string | null,
            period_id: 3,
            period: null as PeriodT | null,
        })

        const data_state = reactive({
            periods: new DataState<PeriodT>({}),
        })

        const min_date = computed(() => {
            const date = new Date(Date.now())
            const hours = date.getHours()

            if (hours >= 14) {
                date.setDate(date.getDate() + 1)
            }

            return date.toISOString().split('T')[0]
        })

        const onPeriodSelected = (period_id: number) => {
            const period = findObjectByValue('id', period_id, data_state.periods.list)

            if (!period) return
            state.period = period
        }

        const isTodayAfternoon = computed(() => {
            const current_date = new Date(),
                current_hour = current_date.getHours()
            const current_date_iso = current_date.toISOString().split('T')[0]

            return current_hour >= 10 && state.date === current_date_iso
        })

        const setPeriod = () => {
            if (isTodayAfternoon.value) {
                state.period_id = 2
            } else {
                state.period_id = 3
            }

            const period = findObjectByValue('id', state.period_id, data_state.periods.list)
            state.period = period || null
        }

        const onDateSelected = () => {
            state.is_period_check = false
            setPeriod()
        }

        const getPeriods = computed(() => {
            if (isTodayAfternoon.value) {
                return data_state.periods.list.filter((period) => period.id === 2)
            }

            return data_state.periods.list
        })

        const loadPeriods = async () => {
            data_state.periods.pagination.current_page = 1

            try {
                data_state.periods.is_loading = true
                const response = await orders.getPeriods()
                data_state.periods.list = response.data

                data_state.periods.pagination.total_pages = 1

                data_state.periods.is_failed = false
                data_state.periods.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.periods.failure.catchError(error)

                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_failed = true
                }
            } finally {
                if (!data_state.periods.failure.error_state.is_cancel) {
                    data_state.periods.is_loading = false
                }
            }
        }

        const onCheckboxChange = (value: boolean) => {
            if (!value) {
                setPeriod()
            }
        }

        const emitCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const emitSubmit = () => {
            if (props.loading) return

            const payload = {
                takeDate: state.date,
                periodId: state.period_id,
            }

            emit('submit', payload)
        }

        onMounted(loadPeriods)

        return {
            state,
            data_state,
            min_date,
            //
            emitCancel,
            emitSubmit,
            onPeriodSelected,
            onDateSelected,
            loadPeriods,
            onCheckboxChange,
            //
            getPeriods,
        }
    },
})
